import { registerPlugin } from '@capacitor/core';

import type { ZebraPDAPlugin } from './definitions';

const ZebraPDA = registerPlugin<ZebraPDAPlugin>('ZebraPDA', {
  web: () => import('./web').then(m => new m.ZebraPDAWeb()),
});

export * from './definitions';
export { ZebraPDA };
